export default "__VITE_ASSET__4ydiNRM7__"